/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  CircularProgress,
  InputBase,
  NativeSelect,
  Switch,
  withStyles,
  Divider,
  Dialog,
} from '@material-ui/core';
import { Formik, useFormik } from 'formik';
import axios from 'axios';
import { get, head, merge } from 'lodash';
import SVG from 'react-inlinesvg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import { ErrorMessage } from '../../components/ErrorMessage';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import { AntTab, AntTabs } from '../../components/Tabs';
import {
  saveShadow,
  schema,
  compareDesiredAndReported,
  geoAnchorSchema,
  bridgeSchema,
  saveBridgeShadow,
} from './utils/index';
import * as Yup from 'yup';
import { MotionContainer } from '../../components/MotionContainer';
import MetadataMenu from '../../components/MetadataMenu';

export const BootstrapInput = withStyles(theme => ({
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#FFFFFF',
    border: '1px solid #ced4da',
    fontSize: 14,
    fontFamily: ['Titillium', 'sans-serif'].join(','),
    padding: '8px 26px 10px 12px',
    transition: theme?.transitions?.create(['border-color', 'box-shadow']),
  },
}))(InputBase);

const tabs = [
  { label: 'General', value: 'general' },
  { label: 'Positioning', value: 'positioning' },
];

const bridgeTabs = [
  { label: 'General', value: 'general' },
  { label: 'Ambient IoT', value: 'wiliot' },
];

const zoneTabs = [
  { label: 'General', value: 'general' },
  { label: 'Metadata', value: 'metadata' },
];

const Input = withStyles(theme => ({
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette?.background?.paper,
    border: '1px solid #ced4da',
    fontSize: 14,
    fontFamily: ['Titillium', 'sans-serif'].join(','),
    padding: '2px 12px 2px 3px',
    transition: theme.transitions?.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

export const GeoAnchor = ({
  intl,
  values,
  hasPermission,
  onSubmit,
  onClose,
  onDelete,
}) => {
  return (
    <Formik
      initialValues={values}
      validationSchema={geoAnchorSchema(intl)}
      enableReinitialize={true}
      onSubmit={onSubmit}
    >
      {({ getFieldProps, errors, touched, handleSubmit, isSubmitting }) => (
        <div className="anchor-popup">
          <form onSubmit={handleSubmit}>
            <div
              className="card-header card-header-bg"
              style={{ padding: '1rem .65rem' }}
            >
              <span style={{ fontSize: '1.2rem', color: '#FFFFFF' }}>
                Geo Anchor
              </span>
            </div>
            <div
              style={{
                background: '#F0F0F1',
                borderRadius: 10,
                padding: '.5rem .65rem',
              }}
            >
              <div className="d-flex align-items-center my-3">
                <div style={{ width: '24%' }}>
                  <span>Latitude</span>
                </div>
                <input
                  type="number"
                  className="mx-3"
                  {...getFieldProps('lat')}
                  style={{
                    background: '#C4C4C4',
                    border: 'none',
                    borderRadius: 2,
                  }}
                />
                <span>Degrees</span>
              </div>
              {touched.lat && errors.lat && (
                <div className="d-flex align-items-center my-3 fv-plugins-message-container">
                  <span className="fv-help-block">{errors.lat}</span>
                </div>
              )}
              <div className="d-flex my-3">
                <div style={{ width: '24%' }}>
                  <span>Longitude</span>
                </div>
                <input
                  type="number"
                  {...getFieldProps('long')}
                  className="mx-3"
                  style={{
                    background: '#C4C4C4',
                    border: 'none',
                    borderRadius: 2,
                  }}
                />
                <span>Degrees</span>
              </div>
              {touched.long && errors.long && (
                <div className="d-flex align-items-center my-3 fv-plugins-message-container">
                  <span className="fv-help-block">{errors.long}</span>
                </div>
              )}
            </div>
            <hr className="w-100 m-0" style={{ background: 'black' }} />
            <div style={{ background: '#F0F0F1', borderRadius: 10 }}>
              <div className="d-flex">
                {(hasPermission('floor-plans/*/things*', 'C') ||
                  hasPermission('floor-plans/*/things*', 'U')) && (
                  <button
                    className="btn btn-primary font-weight-bold px-4 py-1 my-1 ml-2"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    <span>Save</span>
                  </button>
                )}
                <button
                  className="btn btn-primary font-weight-bold px-4 py-1 my-1 ml-2 cancel-bg cancel-btn cancel-text-color"
                  type="button"
                  onClick={onClose}
                >
                  <span>Cancel</span>
                </button>
                {hasPermission('floor-plans/*/things*', 'D') && (
                  <button
                    className="btn btn-primary font-weight-bold px-4 py-1 my-1 ml-2 bg-danger"
                    type="button"
                    onClick={onDelete}
                    disabled={isSubmitting}
                  >
                    <span>Delete</span>
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      )}
    </Formik>
  );
};

export function Anchor({
  setPendencies,
  networks,
  hasPermission,
  isUniqueAnchor,
  mark,
  intl,
  floorPlanId,
  onRemove,
  getMeters,
  callback,
}) {
  const { lat, lng } = mark.getLatLng();
  const dist = getMeters(mark);
  const [activeTab, setActiveTab] = useState('general');
  const [shadow, setShadow] = useState({
    isBridge: false,
    isInitiator: false,
    useEthernet: false,
    positioning: {
      x: dist.x,
      y: dist.y,
      z: '',
    },
    statusInterval: '',
    networkId: '',
  });
  const [reported, setReported] = useState({});
  const [initialValue, setInitialValue] = useState(shadow);
  const [metadata, setMetadata] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const compare = useCallback(compareDesiredAndReported(shadow, reported), [
    shadow,
    reported,
  ]);

  useEffect(() => {
    async function get() {
      setIsLoading(true);
      try {
        const { data } = await axios.get(
          `/thing-shadows/${mark.anchor.thingName}`
        );
        if (data && Object.keys(data).length) {
          const shadow = {
            ...data.uwb.state.desired,
            connectivity: data.connectivity?.state?.desired ?? undefined,
          };
          shadow.networkId =
            shadow?.networkId ?? data.uwb.state?.reported?.networkId;
          shadow.isOrigin =
            data.uwb.state?.desired?.positioning?.x === 0 &&
            data.uwb.state?.desired?.positioning?.y === 0;
          shadow.statusInterval =
            data.classic.state?.desired?.statusInterval ?? 0;
          const metadata = merge(
            data.uwb?.metadata,
            data.connectivity?.metadata
          );
          const reported = merge(
            data.uwb?.state?.reported,
            data.connectivity?.state?.reported
          );
          setShadow(shadow);
          setReported(reported);
          setMetadata(metadata);
          setInitialValue({
            ...shadow,
            networkId:
              shadow?.networkId || reported?.networkId || networks[0].networkId,
          });
        }
      } finally {
        setIsLoading(false);
      }
    }
    get();
  }, [mark]);

  function removeAnchor(e, isOrigin) {
    if (isOrigin && !isUniqueAnchor) {
      setOpen(true);
    } else {
      try {
        e.target.disabled = true;
        const values = { ...shadow };
        delete values.useEthernet;
        delete values.label;
        axios.put(`/thing-shadows/${mark.anchor.thingName}`, {
          oldValues: values,
          newValues: {
            ...values,
            positioning: null,
            isInitiator: false,
            isBridge: false,
            networkId: 0,
            isOrigin: undefined,
            enabled: false,
          },
        });
        onRemove(isOrigin);
      } catch (e) {
        e.target.disabled = false;
      }
    }
  }
  return (
    <div
      className="anchor-popup position-relative"
      style={{ width: 320, overflow: 'hidden' }}
    >
      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute w-100 h-100"
          style={{
            background: 'white',
            opacity: 0.9,
            zIndex: 300,
          }}
        >
          <CircularProgress color="primary" />
        </div>
      )}
      <Formik
        initialValues={initialValue}
        validationSchema={schema(intl)}
        enableReinitialize={true}
        onSubmit={saveShadow(
          callback,
          shadow,
          mark,
          floorPlanId,
          { lat: dist.y, lng: dist.x },
          setPendencies
        )}
      >
        {({
          getFieldProps,
          values,
          errors,
          touched,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <>
            <div className="card-header-bg" style={{ padding: '1rem .65rem' }}>
              <span style={{ fontSize: '1.2rem', color: '#FFFFFF' }}>
                {' '}
                {mark.anchor.thingName}{' '}
              </span>
            </div>
            <div
              style={{
                background: '#F0F0F1',
                borderRadius: 10,
                paddingBottom: '1rem',
              }}
            >
              <AntTabs
                value={activeTab}
                variant="fullWidth"
                onChange={(_, value) => setActiveTab(value)}
                textColor="primary"
                TabIndicatorProps={{
                  color: 'primary',
                }}
              >
                {tabs.map(tab => (
                  <AntTab
                    key={tab.value}
                    style={{ width: 80 }}
                    label={tab.label}
                    value={tab.value}
                  />
                ))}
              </AntTabs>
              {activeTab === 'general' && (
                <>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('networkId') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.networkId
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'networkId', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.networkId.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Network ID</span>
                    </div>
                    <NativeSelect
                      className="form-select mx-3"
                      style={{ width: '48%' }}
                      {...getFieldProps('networkId')}
                      input={<Input />}
                    >
                      {networks.map(opt => (
                        <option value={opt.networkId} key={opt.id}>
                          {' '}
                          {opt.name} ({opt.networkId}){' '}
                        </option>
                      ))}
                    </NativeSelect>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    {compare('isInitiator') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.isInitiator
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'isInitiator', false)
                                      ? 'Yes'
                                      : 'No',
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.isInitiator.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Initiator</span>
                    </div>
                    <div
                      style={{ width: '28%', height: 30 }}
                      className="d-flex align-items-center"
                    >
                      <Switch
                        checked={values.isInitiator}
                        onChange={e => {
                          if (e.target.checked) {
                            setFieldValue('isBridge', false);
                            setFieldValue('isInitiator', true);
                          } else {
                            setFieldValue('isInitiator', false);
                          }
                        }}
                      />
                    </div>
                    <span>{values.isInitiator ? 'Yes' : 'No'}</span>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    {compare('isBridge') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.isBridge
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'isBridge', false)
                                      ? 'Yes'
                                      : 'No',
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.isBridge.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Bridge</span>
                    </div>
                    <div
                      style={{ width: '28%', height: 30 }}
                      className="d-flex align-items-center"
                    >
                      <Switch
                        checked={values.isBridge}
                        onChange={e => {
                          if (e.target.checked) {
                            setFieldValue('isInitiator', false);
                            setFieldValue('isBridge', true);
                          } else setFieldValue('isBridge', false);
                        }}
                      />
                    </div>
                    <span>{values.isBridge ? 'Yes' : 'No'}</span>
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('statusInterval') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.statusInterval
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'statusInterval', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.statusInterval.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Status report interval</span>
                    </div>
                    <input
                      type="number"
                      min={0}
                      {...getFieldProps('statusInterval')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                    <span>seconds</span>
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="statusInterval"
                    />
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    {compare('isOrigin') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.isOrigin
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'isOrigin', false)
                                      ? 'Yes'
                                      : 'No',
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.isOrigin.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Origin Reference</span>
                    </div>
                    <div
                      style={{ width: '28%', height: 30 }}
                      className="d-flex align-items-center"
                    >
                      <Switch
                        checked={values.isOrigin || false}
                        disabled={shadow.isOrigin}
                        onChange={e => {
                          if (e.target.checked) {
                            setFieldValue('isOrigin', true);
                            setFieldValue('positioning.x', 0);
                            setFieldValue('positioning.y', 0);
                          } else {
                            setFieldValue('isOrigin', false);
                            setFieldValue('positioning.x', lat);
                            setFieldValue('positioning.y', lng);
                          }
                        }}
                      />
                    </div>
                    <span>{values.isOrigin ? 'Yes' : 'No'}</span>
                  </div>
                </>
              )}
              {activeTab === 'positioning' && (
                <>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {get(shadow, 'positioning.x') ===
                    get(reported, 'positioning.x') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.positioning
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'positioning.x', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.positioning.x.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>X-Positioning</span>
                    </div>
                    <input
                      type="text"
                      disabled
                      {...getFieldProps('positioning.x')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {get(shadow, 'positioning.y') ===
                    get(reported, 'positioning.y') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.positioning
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'positioning.y', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.positioning.y.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Y-Positioning</span>
                    </div>
                    <input
                      type="text"
                      disabled
                      {...getFieldProps('positioning.y')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {get(shadow, 'positioning.z') ===
                    get(reported, 'positioning.z') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.positioning
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'positioning.z', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.positioning.z.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Height from Ground</span>
                    </div>
                    <input
                      type="number"
                      min={0}
                      {...getFieldProps('positioning.z')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                    <span>meters</span>
                  </div>
                  {touched.positioning?.z && errors.positioning?.z ? (
                    <div className="d-flex ml-2">
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {errors.positioning?.z}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </>
              )}
            </div>
            <hr className="w-100 m-0" style={{ background: 'black' }} />
            <div style={{ background: '#F0F0F1', borderRadius: 10 }}>
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  {hasPermission('thing-shadows/*', 'U') &&
                    hasPermission('things*', 'U') && (
                      <button
                        className="btn btn-primary font-weight-bold px-4 py-1 my-1 ml-2"
                        onClick={handleSubmit}
                        type="button"
                      >
                        <span>{intl.formatMessage({ id: 'SAVE' })}</span>
                        {isSubmitting && (
                          <span className="ml-3 px-2 spinner spinner-white"></span>
                        )}
                      </button>
                    )}
                  <button
                    className="btn btn-primary font-weight-bold px-4 py-1 my-1 ml-2 cancel-bg cancel-btn cancel-text-color"
                    onClick={() => mark.closePopup()}
                    type="button"
                  >
                    <span>{intl.formatMessage({ id: 'CANCEL' })}</span>
                  </button>
                </div>
                <div>
                  {hasPermission('things*', 'U') && (
                    <button
                      className="btn btn-primary font-weight-bold px-4 py-1 my-1 mr-2 bg-danger"
                      type="button"
                      onClick={e => removeAnchor(e, shadow.isOrigin)}
                    >
                      {intl.formatMessage({ id: 'REMOVE' })}
                    </button>
                  )}
                </div>
              </div>
            </div>
            <Dialog onClose={() => setOpen(false)} open={open}>
              <div style={{ minWidth: '500px' }}>
                <div
                  className="col-12 px-4 card-header"
                  style={{ fontWeight: 800 }}
                >
                  <span>{mark.anchor.thingName}</span>
                </div>
                <div
                  className="col-12 py-2 px-4 card-body"
                  style={{ minHeight: 80 }}
                >
                  <span>
                    {intl.formatMessage({ id: 'ERRORS.REMOVE_ORIGIN' })}
                  </span>
                </div>
                <Divider />
                <div
                  className="col-12 px-4 d-flex justify-content-end my-2"
                  style={{ padding: '0px !important' }}
                >
                  <button
                    onClick={() => setOpen(false)}
                    type="button"
                    className="btn danger-bg btn-bordered d-flex align-items-center"
                    style={{ color: '#FFFFFF' }}
                  >
                    {intl.formatMessage({ id: 'ACTIONS.OK' })}
                  </button>
                </div>
              </div>
            </Dialog>
          </>
        )}
      </Formik>
    </div>
  );
}

export function Zone({
  intl,
  zone,
  hasPermission,
  params,
  afterSubmit,
  onCancel,
  onRemove,
  geoJSON,
  getDistFromOrigin,
}) {
  const { areaId, facilityId, floorPlanId } = params;
  const addMetadataButton = useRef(null);
  const [activeTab, setActiveTab] = useState('general');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setActiveTab('general');
  }, []);

  const formik = useFormik({
    initialValues: zone,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
        .matches(
          /^[!-ÿ\s]*$/,
          intl.formatMessage({ id: 'ADMINISTRATION.NAME.REGEX' })
        ),
      description: Yup.string().required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
      externalId: Yup.string()
        .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
        .matches(
          /^[a-z0-9-.]*$/,
          intl.formatMessage({ id: 'ADMINISTRATION.CODE.REGEX' })
        ),
    }),
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      try {
        values.geoJson = geoJSON(values.id);
        let isUpdate = false;
        if (values.id) {
          isUpdate = true;
          if (values.geoJson.type !== 'Feature')
            values.geoJson = head(values.geoJson.features);
          values.geoJsonFromOrigin = getDistFromOrigin(values);
          await axios.put(
            `/areas/${areaId}/facilities/${facilityId}/floor-plans/${floorPlanId}/zones/${values.id}`,
            values
          );
        } else {
          values.geoJsonFromOrigin = getDistFromOrigin(values);
          const { data } = await axios.post(
            `/areas/${areaId}/facilities/${facilityId}/floor-plans/${floorPlanId}/zones`,
            values
          );
          values.id = data.id;
        }
        afterSubmit(values, isUpdate);
      } finally {
        setSubmitting(false);
      }
    },
  });

  async function onDelete() {
    if (zone.id)
      await axios.delete(
        `/areas/${areaId}/facilities/${facilityId}/floor-plans/${floorPlanId}/zones/${zone.id}`
      );
    onRemove(zone.id);
  }

  return (
    <MotionContainer
      className="anchor-popup position-relative"
      key={zone.id}
      style={{ width: 380, overflow: 'hidden' }}
    >
      <div
        className="card-header-bg d-flex justify-content-between"
        style={{ padding: '1rem', minHeight: 48 }}
      >
        <span style={{ fontSize: '1.2rem', color: '#FFFFFF' }}>
          {' '}
          {get(formik, 'values.name')}{' '}
        </span>
        {activeTab === 'metadata' && (
          <span className="svg svg-icon cursor-pointer" ref={addMetadataButton}>
            <SVG
              uniquifyIDs
              cacheRequests
              src={toAbsoluteUrl('/media/svg/senseworks/add_circle.svg')}
            />
          </span>
        )}
      </div>
      <AntTabs
        value={activeTab}
        variant="fullWidth"
        onChange={(_, value) => setActiveTab(value)}
        textColor="primary"
        TabIndicatorProps={{
          color: 'primary',
        }}
      >
        {zoneTabs.map(tab => (
          <AntTab
            key={tab.label}
            value={tab.value}
            label={tab.label}
            disabled={tab.value === 'metadata' && !zone.id}
          />
        ))}
      </AntTabs>
      {activeTab === 'general' ? (
        <form onSubmit={formik.handleSubmit}>
          <div className="px-4 py-3">
            <div className="d-flex align-items-center" style={{ height: 30 }}>
              <div style={{ width: 110 }}>
                <span style={{ width: 110 }}>ID</span>
              </div>
              <input
                type="text"
                {...formik.getFieldProps('externalId')}
                className="ml-3 p-2 outline-none"
                style={{
                  background: '#FFFFFF',
                  border: 'none',
                  borderRadius: 4,
                  width: '100%',
                }}
              />
            </div>
            <div style={{ marginLeft: 100 }}>
              <ErrorMessage formik={formik} field="externalId" />
            </div>
            <div
              className="d-flex align-items-center my-2"
              style={{ height: 30 }}
            >
              <div style={{ width: 110 }}>
                <span style={{ width: 110 }}>
                  {intl.formatMessage({ id: 'NAME' })}
                </span>
              </div>
              <input
                type="text"
                {...formik.getFieldProps('name')}
                className="ml-3 p-2 outline-none"
                style={{
                  background: '#FFFFFF',
                  border: 'none',
                  borderRadius: 4,
                  width: '100%',
                }}
              />
            </div>
            <div style={{ marginLeft: 100 }}>
              <ErrorMessage formik={formik} field="name" />
            </div>
            <div
              className="d-flex align-items-center mt-2"
              style={{ height: 30 }}
            >
              <div style={{ width: 110 }}>
                <span style={{ width: 110 }}>
                  {intl.formatMessage({ id: 'DESCRIPTION' })}
                </span>
              </div>
              <input
                type="text"
                {...formik.getFieldProps('description')}
                className="ml-3 p-2 outline-none"
                style={{
                  background: '#FFFFFF',
                  border: 'none',
                  borderRadius: 4,
                  width: '100%',
                }}
              />
            </div>
            <div style={{ marginLeft: 100 }}>
              <ErrorMessage formik={formik} field="description" />
            </div>
          </div>
          <Divider />
          <div className="d-flex justify-content-between px-4 py-2">
            <div className="d-flex">
              {hasPermission('zones*', 'U') && (
                <>
                  <button
                    type="submit"
                    style={{ width: 60 }}
                    onClick={formik.handleSubmit}
                    className="btn btn-bordered px-2 h-25px d-flex align-items-center btn-primary justify-content-center"
                  >
                    <span>{intl.formatMessage({ id: 'SAVE' })}</span>
                    {formik && formik.isSubmitting && (
                      <span className="ml-3 px-3 spinner spinner-white"></span>
                    )}
                  </button>
                </>
              )}
              <button
                type="button"
                style={{ width: 60 }}
                onClick={() => onCancel(zone.id)}
                className="btn ml-3 btn-bordered cancel-bg cancel-btn cancel-text-color h-25px d-flex align-items-center justify-content-center"
              >
                <span>{intl.formatMessage({ id: 'CANCEL' })}</span>
              </button>
            </div>
            {hasPermission('zones*', 'D') && (
              <button
                type="button"
                style={{ color: '#FFFFFF', width: 60 }}
                onClick={() => (zone.id ? setOpen(true) : onDelete())}
                className="btn btn-bordered bg-danger h-25px d-flex align-items-center justify-content-center"
              >
                <span>{intl.formatMessage({ id: 'DELETE' })}</span>
              </button>
            )}
          </div>
        </form>
      ) : (
        <MetadataMenu
          hasPermission={hasPermission}
          type="zone"
          id={zone.id}
          intl={intl}
          buttonRef={addMetadataButton}
          displayHeader={false}
        />
      )}
      <Dialog onClose={() => setOpen(false)} open={open}>
        <div style={{ minWidth: '500px' }}>
          <div className="col-12 px-4 card-header" style={{ fontWeight: 800 }}>
            <span>
              {intl.formatMessage({ id: 'ACTIONS.REMOVE.ZONE.TITLE' })}
            </span>
          </div>
          <div className="col-12 py-2 px-4 card-body" style={{ minHeight: 80 }}>
            <span>
              {intl.formatMessage({ id: 'ACTIONS.REMOVE.ZONE.BODY' })}
            </span>
            <span className="font-weight-bolder ml-1">
              {intl.formatMessage({ id: 'NAME_VALUE' }, { name: zone.name })}.
            </span>
            <p className="attention">
              {intl.formatMessage({ id: 'ACTIONS.CANNOT_REVERT' })}
            </p>
          </div>
          <Divider />
          <div
            className="col-12 px-4 d-flex justify-content-end my-2"
            style={{ padding: '0px !important' }}
          >
            <button
              onClick={() => {
                setOpen(false);
                onDelete();
              }}
              type="button"
              className="btn btn-bordered danger-bg d-flex align-items-center"
              style={{ color: '#FFFFFF', height: 26 }}
            >
              {intl.formatMessage({ id: 'DELETE' })}
            </button>
            <button
              onClick={() => setOpen(false)}
              type="button"
              className="ml-3 btn btn-bordered d-flex align-items-center"
              style={{ color: '#58595B', height: 26 }}
            >
              {intl.formatMessage({ id: 'CANCEL' })}
            </button>
          </div>
        </div>
      </Dialog>
    </MotionContainer>
  );
}

export function Scale({
  intl,
  floorPlan,
  mark,
  url,
  dist,
  setFloorPlan,
  afterUpdate,
}) {
  const formik = useFormik({
    initialValues: {
      ...floorPlan,
      measureUnit: 'm',
      scale: '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      scale: Yup.number()
        .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
        .min(
          1,
          intl.formatMessage({ id: 'AUTH.VALIDATION.MIN_VALUE_FIELD' }) + ' 1'
        ),
      measureUnit: Yup.string().required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
    }),
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      try {
        let enteredScale = +values.scale;
        if (values.measureUnit === 'ft') {
          enteredScale = enteredScale * 0.3048;
        }
        const scale = 1 / (+dist / enteredScale);
        setSubmitting(true);
        await axios.put(url, {
          ...floorPlan,
          scale,
          measureUnit: values.measureUnit,
          processingGroupId: values.processingGroupId || null,
        });
        setFloorPlan({
          ...floorPlan,
          scale,
          measureUnit: values.measureUnit,
        });
        afterUpdate(scale);
        mark.closePopup();
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <MotionContainer
      className="anchor-popup position-relative"
      key={floorPlan?.id}
      style={{ width: 260, overflow: 'hidden' }}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 py-3">
          <div className="d-flex align-items-center" style={{ height: 45 }}>
            <div style={{ width: 60 }}>
              <span style={{ width: 60 }}>
                {intl.formatMessage({ id: 'DISTANCE' })}
              </span>
            </div>
            <input
              type="number"
              defaultValue=""
              onChange={e => {
                formik.setFieldValue('scale', +e.target.value);
              }}
              className="ml-3 p-3 outline-none mr-3"
              style={{ border: 'none', borderRadius: 4, width: 80 }}
            />
            <NativeSelect
              className="form-select"
              style={{ width: '100%', height: 40.5 }}
              {...formik.getFieldProps('measureUnit')}
              input={<BootstrapInput />}
            >
              {[
                { id: 'm', description: 'Meters' },
                { id: 'ft', description: 'Feet' },
              ].map(opt => (
                <option value={opt.id} key={opt.id}>
                  {' '}
                  {opt.description}{' '}
                </option>
              ))}
            </NativeSelect>
          </div>
          <ErrorMessage field="scale" formik={formik} />
        </div>
        <Divider />
        <div className="d-flex justify-content-between px-4 py-2">
          <div className="d-flex">
            <button
              type="submit"
              style={{ width: 60 }}
              onClick={formik.handleSubmit}
              className="btn btn-bordered px-2 h-25px d-flex align-items-center btn-primary justify-content-center"
            >
              <span>{intl.formatMessage({ id: 'SAVE' })}</span>
              {formik && formik.isSubmitting && (
                <span className="ml-3 px-3 spinner spinner-white"></span>
              )}
            </button>
            <button
              type="button"
              style={{ width: 60 }}
              onClick={() => mark.closePopup()}
              className="btn ml-3 btn-bordered cancel-bg cancel-btn cancel-text-color h-25px d-flex align-items-center justify-content-center"
            >
              <span>{intl.formatMessage({ id: 'CANCEL' })}</span>
            </button>
          </div>
        </div>
      </form>
    </MotionContainer>
  );
}

export function Bridge({
  setPendencies,
  hasPermission,
  mark,
  intl,
  floorPlanId,
  onRemove,
  callback,
}) {
  const [activeTab, setActiveTab] = useState('general');
  const [shadow, setShadow] = useState({
    statusInterval: 0,
    gatewayMode: false,
    supportThirdPartyBridges: true,
    txPeriodMs: 0,
    rxTxPeriodMs: 0,
    energyPattern: 0,
    pacerInterval: 0,
    sub1GhzFrequency: 0,
    globalPacingGroup: 0,
  });
  const [reported, setReported] = useState({});
  const [initialValue, setInitialValue] = useState(shadow);
  const [metadata, setMetadata] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const compare = useCallback(compareDesiredAndReported(shadow, reported), [
    shadow,
    reported,
  ]);

  useEffect(() => {
    async function get() {
      setIsLoading(true);
      try {
        const { data } = await axios.get(
          `/thing-shadows/${mark.anchor.thingName}`
        );
        if (data && Object.keys(data).length) {
          const ble = data.ble;
          const shadow = {
            ...ble.state.desired?.wiliot,
          };
          shadow.statusInterval =
            data.classic.state?.desired?.statusInterval ?? 0;
          shadow.gatewayMode =
            data.classic.state?.desired?.gatewayMode ?? false;
          const metadata = merge(ble?.metadata, data.classic?.metadata);
          const reported = merge(
            ble?.state?.reported,
            data.classic?.state?.reported
          );
          setShadow(shadow);
          setReported(reported);
          setMetadata(metadata);
          setInitialValue(shadow);
        }
      } finally {
        setIsLoading(false);
      }
    }
    get();
  }, [mark]);

  function removeBridge(e) {
    try {
      e.target.disabled = true;
      const values = { ...shadow };
      axios.put(`/thing-shadows/${mark.anchor.thingName}`, {
        oldValues: values,
        newValues: {
          ...values,
        },
      });
      onRemove();
    } catch (e) {
      e.target.disabled = false;
    }
  }
  return (
    <div
      className="anchor-popup position-relative"
      style={{ width: 320, overflow: 'hidden' }}
    >
      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute w-100 h-100"
          style={{
            background: 'white',
            opacity: 0.9,
            zIndex: 300,
          }}
        >
          <CircularProgress color="primary" />
        </div>
      )}
      <Formik
        initialValues={initialValue}
        validationSchema={bridgeSchema(intl)}
        enableReinitialize={true}
        onSubmit={saveBridgeShadow(callback, shadow, mark, floorPlanId)}
      >
        {({
          getFieldProps,
          values,
          errors,
          touched,
          handleSubmit,
          isSubmitting,
        }) => (
          <>
            <div className="card-header-bg" style={{ padding: '.4rem .65rem' }}>
              <span
                className="font-weight-bolder"
                style={{ fontSize: '1.2rem', color: '#FFFFFF' }}
              >
                {' '}
                {mark.anchor.thingName}{' '}
              </span>
              <span
                className="d-block"
                style={{ fontSize: '0.9rem', color: '#FFFFFF' }}
              >
                {' '}
                {mark.anchor.marketingName}{' '}
              </span>
            </div>
            <div
              style={{
                background: '#F0F0F1',
                borderRadius: 10,
                paddingBottom: '1rem',
              }}
            >
              <AntTabs
                value={activeTab}
                variant="fullWidth"
                onChange={(_, value) => setActiveTab(value)}
                textColor="primary"
                TabIndicatorProps={{
                  color: 'primary',
                }}
              >
                {bridgeTabs.map(tab => (
                  <AntTab
                    key={tab.value}
                    style={{ width: 80 }}
                    label={tab.label}
                    value={tab.value}
                  />
                ))}
              </AntTabs>
              {activeTab === 'general' && (
                <>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('gatewayMode') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.gatewayMode
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'gatewayMode', false)
                                      ? 'Yes'
                                      : 'No',
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.gatewayMode.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Gateway Mode</span>
                    </div>
                    <div
                      style={{ width: '28%', height: 30 }}
                      className="d-flex align-items-center"
                    >
                      <Switch
                        checked={values.gatewayMode}
                        {...getFieldProps('gatewayMode')}
                      />
                    </div>
                    <span className="ml-6">
                      {values.gatewayMode ? 'Yes' : 'No'}
                    </span>
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="statusInterval"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('statusInterval') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.statusInterval
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'statusInterval', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.statusInterval.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Status report interval</span>
                    </div>
                    <input
                      type="number"
                      min={0}
                      {...getFieldProps('statusInterval')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                    <span>seconds</span>
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="statusInterval"
                    />
                  </div>
                </>
              )}
              {activeTab === 'wiliot' && (
                <>
                  <div className="d-flex my-2 align-items-center">
                    {compare('supportThirdPartyBridges') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.supportThirdPartyBridges
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(
                                      reported,
                                      'supportThirdPartyBridges',
                                      false
                                    )
                                      ? 'Yes'
                                      : 'No',
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.supportThirdPartyBridges.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>
                        Support 3rd-Party bridges
                      </span>
                    </div>
                    <div
                      style={{ width: '28%', height: 30 }}
                      className="d-flex align-items-center"
                    >
                      <Switch
                        checked={values.supportThirdPartyBridges}
                        {...getFieldProps('supportThirdPartyBridges')}
                      />
                    </div>
                    <span>
                      {values.supportThirdPartyBridges ? 'Yes' : 'No'}
                    </span>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    {compare('txPeriodMs') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.txPeriodMs
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'txPeriodMs', false)
                                      ? 'Yes'
                                      : 'No',
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.txPeriodMs.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>
                        Transmission Period (ms)
                      </span>
                    </div>
                    <input
                      disabled
                      type="number"
                      min={0}
                      {...getFieldProps('txPeriodMs')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="txPeriodMs"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('rxTxPeriodMs') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.rxTxPeriodMs
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'rxTxPeriodMs', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.rxTxPeriodMs.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>
                        Receive Transmission Period (ms)
                      </span>
                    </div>
                    <input
                      disabled
                      type="number"
                      min={0}
                      {...getFieldProps('rxTxPeriodMs')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="rxTxPeriodMs"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('energyPattern') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.energyPattern
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'energyPattern', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.energyPattern.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Energy Pattern</span>
                    </div>
                    <input
                      disabled
                      type="number"
                      min={0}
                      {...getFieldProps('energyPattern')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="energyPattern"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('pacerInterval') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.pacerInterval
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(reported, 'pacerInterval', ''),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.pacerInterval.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Pacer Interval</span>
                    </div>
                    <input
                      disabled
                      type="number"
                      min={0}
                      {...getFieldProps('pacerInterval')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="pacerInterval"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('sub1GhzFrequency') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.sub1GhzFrequency
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(
                                      reported,
                                      'sub1GhzFrequency',
                                      ''
                                    ),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.sub1GhzFrequency.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Sub-1GHz Frequency</span>
                    </div>
                    <input
                      disabled
                      type="number"
                      min={0}
                      {...getFieldProps('sub1GhzFrequency')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="sub1GhzFrequency"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center my-2"
                    style={{ height: 30 }}
                  >
                    {compare('globalPacingGroup') ? (
                      <SVG
                        uniquifyIDs
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/online-status.svg'
                        )}
                        cacheRequests
                        className="mx-3"
                      />
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip bsPrefix="tooltip-attention">
                            {reported.globalPacingGroup
                              ? intl.formatMessage(
                                  { id: 'SHADOW_LAST_UPDATE' },
                                  {
                                    value: get(
                                      reported,
                                      'globalPacingGroup',
                                      ''
                                    ),
                                    lastTime: moment
                                      .unix(
                                        get(
                                          metadata,
                                          'reported.globalPacingGroup.timestamp'
                                        )
                                      )
                                      .utc()
                                      .format('DD MMM YYYY HH:mm:ss z'),
                                  }
                                )
                              : intl.formatMessage({ id: 'PENDING_SYNC' })}
                          </Tooltip>
                        }
                      >
                        <SVG
                          uniquifyIDs
                          src={toAbsoluteUrl(
                            '/media/svg/senseworks/pending-status.svg'
                          )}
                          cacheRequests
                          className="mx-3"
                        />
                      </OverlayTrigger>
                    )}
                    <div style={{ width: 115 }}>
                      <span style={{ width: 115 }}>Global pacing Group</span>
                    </div>
                    <input
                      disabled
                      type="number"
                      min={0}
                      {...getFieldProps('globalPacingGroup')}
                      className="mx-3"
                      style={{
                        background: '#C4C4C4',
                        border: 'none',
                        borderRadius: 2,
                        width: '28%',
                      }}
                    />
                  </div>
                  <div className="ml-2">
                    <ErrorMessage
                      formik={{ errors, touched }}
                      field="globalPacingGroup"
                    />
                  </div>
                </>
              )}
            </div>
            <hr className="w-100 m-0" style={{ background: 'black' }} />
            <div style={{ background: '#F0F0F1', borderRadius: 10 }}>
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  {hasPermission('thing-shadows/*', 'U') &&
                    hasPermission('things*', 'U') && (
                      <button
                        className="btn btn-primary font-weight-bold px-4 py-1 my-1 ml-2"
                        onClick={handleSubmit}
                        type="button"
                      >
                        <span>{intl.formatMessage({ id: 'SAVE' })}</span>
                        {isSubmitting && (
                          <span className="ml-3 px-2 spinner spinner-white"></span>
                        )}
                      </button>
                    )}
                  <button
                    className="btn btn-primary font-weight-bold px-4 py-1 my-1 ml-2 cancel-bg cancel-btn cancel-text-color"
                    onClick={() => mark.closePopup()}
                    type="button"
                  >
                    <span>{intl.formatMessage({ id: 'CANCEL' })}</span>
                  </button>
                </div>
                <div>
                  {hasPermission('things*', 'U') && (
                    <button
                      className="btn btn-primary font-weight-bold px-4 py-1 my-1 mr-2 bg-danger"
                      type="button"
                      onClick={e => removeBridge(e, shadow.isOrigin)}
                    >
                      {intl.formatMessage({ id: 'REMOVE' })}
                    </button>
                  )}
                </div>
              </div>
            </div>
            <Dialog onClose={() => setOpen(false)} open={open}>
              <div style={{ minWidth: '500px' }}>
                <div
                  className="col-12 px-4 card-header"
                  style={{ fontWeight: 800 }}
                >
                  <span>{mark.anchor.thingName}</span>
                </div>
                <div
                  className="col-12 py-2 px-4 card-body"
                  style={{ minHeight: 80 }}
                >
                  <span>
                    {intl.formatMessage({ id: 'ERRORS.REMOVE_ORIGIN' })}
                  </span>
                </div>
                <Divider />
                <div
                  className="col-12 px-4 d-flex justify-content-end my-2"
                  style={{ padding: '0px !important' }}
                >
                  <button
                    onClick={() => setOpen(false)}
                    type="button"
                    className="btn danger-bg btn-bordered d-flex align-items-center"
                    style={{ color: '#FFFFFF' }}
                  >
                    {intl.formatMessage({ id: 'ACTIONS.OK' })}
                  </button>
                </div>
              </div>
            </Dialog>
          </>
        )}
      </Formik>
    </div>
  );
}
